/**
 * Validation utilities
 */

/**
 * Validates if a string is a valid UUID (v4)
 * @param value - String to validate
 * @returns True if valid UUID, false otherwise
 */
export function isValidUuid(value: string): boolean {
  const uuidRegex =
    /^[\da-f]{8}-[\da-f]{4}-4[\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}$/i;
  return uuidRegex.test(value);
}
